import React, { useContext, useEffect } from 'react';
import { Field } from 'react-final-form';
import { FormCollectionContext } from '../FormCollection/FormCollectionContext.js';

const FormField = (props)=>{
    const { registerField, unregisterField } = useContext(FormCollectionContext);
    const { name } = props;
    useEffect(()=>{
        registerField(name);
        return ()=>unregisterField(name);
    }, [
        name
    ]);
    return /*#__PURE__*/ React.createElement(Field, props);
};

export { FormField };
//# sourceMappingURL=FormField.js.map
